module.exports = __webpack_public_path__ + "static/media/musictown.3a92bd3d.png";